import stk500v1 from '../drivers/stk500v1';

const firmwarev1 = (serialPort, data, progressHandle, callback) => {
    const t = typeof data;
    if (t == 'string') {
        stk500v1(serialPort, data, progressHandle, callback);
    } else if (data instanceof ArrayBuffer) {
        const d = new TextDecoder('utf-8').decode(new Uint8Array(data));
        stk500v1(serialPort, d, progressHandle, callback);
    } else {
        console.error('Firmware stk500v1 failed! Invalid data type ', data);
        callback('unsupported image data type');
    }
};
export default firmwarev1;